import React from 'react';
import PropTypes from 'prop-types';

import QuestionResults from '../QuestionResults';

function SinglePageDisplay(props) {
  const { sections, engagementSummary, introduction, conclusion, createdAt } = props;

  return (
    <>
      {introduction}
      {sections.map((section) => {
        return (
          <div key={section.uuid} className="results-summary__section">
            <h5 className="results-summary__section__title">{section.title}</h5>
            {section.questions.map((question) => {
              return (
                <div key={question.uuid} className="results-summary__question-results">
                  <h2 className="results-summary__question-results__title title is-5 is-primary-color">
                    {question.title}
                  </h2>
                  <QuestionResults
                    question={question}
                    engagementSummary={engagementSummary}
                    createdAt={createdAt}
                  />
                </div>
              );
            })}
          </div>
        );
      })}
      {conclusion}
    </>
  );
}

SinglePageDisplay.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      questions: PropTypes.arrayOf(
        PropTypes.shape({
          uuid: PropTypes.string.isRequired,
          title: PropTypes.string.isRequired,
          type: PropTypes.string,
        })
      ),
    })
  ).isRequired,
  engagementSummary: PropTypes.shape({}).isRequired,
  createdAt: PropTypes.string.isRequired,
  introduction: PropTypes.element,
  conclusion: PropTypes.element,
};

SinglePageDisplay.defaultProps = {
  introduction: null,
  conclusion: null,
};

export default SinglePageDisplay;
